import React from "react"
import { Button } from "react-bootstrap"
import axios from "axios"
import swal from "sweetalert"
import { useHistory } from 'react-router-dom'

import EditAssessmentModal from "./EditAssessmentModal"
import CreateEditTrainingModal from "./CreateEditTrainingModal"
import AssignToGroupModal from "./AssignToGroupModal"
import DeleteTrainingModal from "./DeleteTrainingModal"
import { handleErrorFetchingData } from "../../../../functions/errorHandling"


export default function Training({ training, getTrainingDetails, getTrainings, getTrainingMetadata }) {
  const history = useHistory()

  const handlePublish = () => {
    swal({
      text: `${ training.is_published ? "Un-Publishing" : "Publishing" } ${ training.name }... Please stand by.`,
      icon: require("../../../../static/images/spinner.gif"),
      button: false
    })
    axios.patch(training.url, { is_published: !training.is_published }, {
      headers: { "Authorization": `Bearer ${localStorage.getItem("token")}` }
    }).then(response => {
      swal({
        title: "Success",
        text: `${ training.name } has been ${ training.is_published ? "Un-Published" : "Published" }`,
        icon: "success",
        button: "Continue",
      })
      getTrainings()
    }).catch(error => {
      handleErrorFetchingData(error)
    })
  }

  const goToAssessmentPreview = () => {
    history.push(`/manager/qms-training-assessment-preview/${training.assessment_id}`)
  }

  return (
    <div>
      <div>
        <CreateEditTrainingModal training={ training } getTrainings={ getTrainings } mode="edit" />
      </div>
{/*<div>*/}
      {/*  <DocumentViewer documents={ training.training_documents } />*/}
      {/*</div>*/}
      <div>
        <EditAssessmentModal training={ training } getTrainingDetails={ getTrainingDetails } />
      </div>
      { training.assessment &&
        <React.Fragment>
          <Button onClick={goToAssessmentPreview}>Preview Assessment</Button>
          <div>
            <AssignToGroupModal training={ training } />
{/*<Button>Assign to User</Button>*/}
          </div>
          <Button onClick={ handlePublish }>{ training.is_published ? "Un-Publish" : "Publish" } Training</Button>
        </React.Fragment>
      }
      <div>
          <DeleteTrainingModal training={ training } getTrainings={ getTrainings } getTrainingMetadata={ getTrainingMetadata }/>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTrainingManager/TrainingContainer/Training.js